import HTTP from "../../http";
import { generateQueryString } from "../../../utils";

const PRODUCTS_ENDPOINT = "/products";
const SIMILARS_ENDPOINT = "/similars";

export async function getProductInfo(id) {
  return await HTTP.get(PRODUCTS_ENDPOINT + `/${id}`);
}

export async function getSimilars(id, n) {
  return await HTTP.get(
    PRODUCTS_ENDPOINT +
      SIMILARS_ENDPOINT +
      generateQueryString({ productId: id, numberOfItems: n })
  );
}
